<template>
    <div>
        <div class="container">
            <div class="row px-3">
                <div v-for="course in classesData" :key="course.id"
                    class="col-md-4 d-flex flex-column align-items-center justify-content-start pb-3 px-3"
                   @click="goToCourse(course.link)"
                    style="cursor: pointer; text-decoration: none;">

                    <!-- <img :src="`${$API_ASSETS}${show.banner_image.id}.png`" class="img-fluid py-2" />   -->
                    <div class="position-relative">
                        <img v-if="course.banner_image && course.banner_image.id"
                            :src="`${$API_ASSETS}${course.banner_image.id}.png`" class="img-fluid py-2" />
                        <img v-if="course.core_req"
                            src="CoreRequired.png"
                            class="position-absolute"
                            style="bottom: -15%; width: 25%; transform: translate(-120%,0%);" />
                    </div>

                    <div class="text-start py-2 text-overlay">
                        <span class="fs-3 text-uppercase oswald-bold pt-1">{{ course.name }}</span>
                        <div class="h5 oswald-bold pt-1">{{ course.meets_text }}</div>
                        <!-- <div class="oswald-bold pt-1" v-if="course.core_req">NOTE: Enrollment is only open to those who
                            have completed our Core
                            class.</div> -->
                        <div class="m-0 py-2">{{ course.description || '' }}</div>

                        <!-- <div class="m-0 py-2">{{ course.logistics_text || '' }}</div> -->

                    </div>
                    <div class="w-100 text-start">
                        <a :href="`${course.link}`" class="cardlink text-uppercase pb-5"> Register
                            <i class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
        <div class="container-fluid bg-site-yellow">
            <div class="container-fluid py-5">
                <!-- <div class="row ">


                </div> -->
                <div class="row ">
                    <div class="col-md-5 col-12 offset-md-1">
                        <div class="h1 oswald-bold text-uppercase pb-3 text-center text-md-start"> Class Schedule </div>
                        <div class="h5 text-black">Spring Semester</div>
                        <div class="pb-4">Begins early February (registration opens mid December)</div>
                        <div class="h5 text-black">Summer Semester</div>
                        <div class="pb-4">Begins late May (registration opens late April) </div>
                        <div class="h5 text-black">Fall Semester</div>
                        <div class="pb-4">Begins late September (registration opens late August)</div>
                    </div>
                    <div class="col-md-5 col-12">

                        <div class="pb-2" v-for="section in sectionData" :key="section.id">
                            <div class="row">
                                <div class="oswald-bold  col-md-4 col-6 py-3"> {{ getDayOfWeek(section.start_dt) }} {{
                                    format12HourTime(section.start_dt) }} </div>

                                <div class="col-md-8 col-6 text-start  py-3">
                                    {{ section.course.name }}</div>
                                <div   style="height: 1px; background-color: gray; width: 100%; margin: 0;"></div>
                                <!-- <span> Starts {{ formatMonthDay(section.start_dt) }}</span> -->
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AllClasses',
    data() {
        return {
            classesData: [],
            semesterData: [],
            sectionData: []
        };
    },
    methods: {
        goToCourse(link) {
            window.location.href = `${link}`;
        },
        async fetchClassData() {
            try {
                const response = await axios.post(this.$API_GRAPHQL, {
                    query: `
                      query {
                    courses: class {
                        id
                        name
                        description
                        meets_text
                        logistics_text
                        link
                        display_order
                        core_req
                        banner_image {
                            id
                        }
                        session_id{
                            start_dt
                        }
                    }
                    semester:semester_details{
                        id
                        number_of_sessions
                        sale_dt
                        start_date
                        banner_title
                    }
            courseSection: class_session {
                id
                start_dt
                course:class_id{
                    id
                    name
                }
            }


            }

                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });

                this.classesData = (response.data.data.courses || []).sort((a, b) => a.display_order - b.display_order);
                this.semesterData = response.data.data.semester || [];
                this.sectionData = (response.data.data.courseSection || []).sort((a, b) => new Date(a.start_dt) - new Date(b.start_dt));
                console.log('Fetched Class Data:', this.classesData);
            } catch (error) {
                console.error('Error fetching class data:', error);
            }
        },
        getDayOfWeek(start_dt) {
            const date = new Date(start_dt);
            return date.toLocaleDateString('en-US', { weekday: 'long' });
        },
        format12HourTime(isoString) {
            const date = new Date(isoString);
            let hours = date.getHours() % 12 || 12; // Convert 24-hour to 12-hour format, ensuring 12 is correctly represented
            // let period = date.getHours() >= 12 ? 'PM' : 'AM';
            let intHours = parseInt(hours);
            let endHours = intHours + 2;

            return `${intHours} - ${endHours} pm`; // Format as "3PM"
        },
        formatMonthDay(isoString) {
            const date = new Date(isoString);
            return `${date.getMonth() + 1}/${date.getDate()}`; // getMonth() is zero-based, so add 1
        }

    },
    created() {
        this.fetchClassData();
    }
};
</script>

<style scoped>
.text-overlay {
  position: relative;
  z-index: 2;
}
</style>
